export const SUCCESS_LOGGIN = 'SUCCESS_LOGGIN' 

export const LOADED_USER_INFO = 'LOADED_USER_INFO' 